module.exports = __webpack_public_path__ + "img/my_location_english_icon.b081e708.png";